import React from 'react';
/*** The container for the search layover.*/
import SearchContainer from '../components/search/SearchContainer';
/** The container for the search results.*/
import ResultsContainer from '../templates/components/search-results/ResultsContainer';
import { ShopifyProductActionsProvider } from '../contexts/ShopifyProductActionsProvider';
import { Portal } from '../components/portal/Portal';

export const SearchPortal = () => {
  const searchContainerRoot = document.querySelector('#search-layover-container') as HTMLElement | null;
  const searchResultsRoot = document.querySelector('#search-results-container') as HTMLElement | null;

  return (
    <>
      {searchContainerRoot ? (
        <Portal container={searchContainerRoot}>
          <SearchContainer />
        </Portal>
      ) : null}
      {searchResultsRoot ? (
        <Portal container={searchResultsRoot}>
          <ShopifyProductActionsProvider attachPageType="search">
            <ResultsContainer />
          </ShopifyProductActionsProvider>
        </Portal>
      ) : null}
    </>
  );
};
